import { render, staticRenderFns } from "./ModalOnboard.vue?vue&type=template&id=604f2e5a&scoped=true&"
import script from "./ModalOnboard.vue?vue&type=script&lang=ts&"
export * from "./ModalOnboard.vue?vue&type=script&lang=ts&"
import style0 from "./ModalOnboard.vue?vue&type=style&index=0&id=604f2e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f2e5a",
  null
  
)

export default component.exports